<script lang="ts" setup>
import { ref, watch } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { ImageActionService } from './ImageAction.service';

const imageActionService = useService(ImageActionService);
</script>

<template></template>
